import React, { useState, useEffect, useRef } from "react";
import "./AdminLayout.css";
import Header from "./Header/Header";
import Sidebar from "./Sidebar/Sidebar";
import { Outlet } from "react-router-dom";
import Footer from "./Footer/Footer";

export default function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const sidebarRef = useRef(null);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setSidebarOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <section className="layout-container layout-container-content">
      <aside
        role="complementary"
        ref={sidebarRef}
        className={`layout-sidebar ${sidebarOpen ? "open" : ""}`}
      >
        <Sidebar toggleSidebar={toggleSidebar} />
      </aside>

      <section className="layout-container is-vertical">
        <header role="heading" className="layout-header">
          <Header />
          <button className="sidebar-toggle" onClick={toggleSidebar}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="icon icon-tabler icon-tabler-menu-2"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="#fff"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M4 6l16 0" />
              <path d="M4 12l16 0" />
              <path d="M4 18l16 0" />
            </svg>
          </button>
        </header>

        <main role="main" className="layout-main">
          <Outlet />
        </main>

        <footer role="contentinfo" className="layout-footer">
          <Footer />
        </footer>
      </section>
    </section>
  );
}
